import { Preferences } from './WebPreferences';

const COINS_KEY = 'coinBalance';
const AD_WATCHES_KEY = 'coinAdWatches';
const AD_WATCHES_DATE_KEY = 'coinAdWatchesDate';
const COINS_PER_AD = 5;
const MAX_ADS_PER_DAY = 3;

let cachedBalance = null;

export async function getCoins() {
  if (cachedBalance !== null) return cachedBalance;
  const { value } = await Preferences.get({ key: COINS_KEY });
  cachedBalance = parseInt(value) || 0;
  return cachedBalance;
}

export async function addCoins(amount) {
  const current = await getCoins();
  cachedBalance = current + amount;
  await Preferences.set({ key: COINS_KEY, value: String(cachedBalance) });
  return cachedBalance;
}

export async function spendCoins(amount) {
  const current = await getCoins();
  if (current < amount) return false;
  cachedBalance = current - amount;
  await Preferences.set({ key: COINS_KEY, value: String(cachedBalance) });
  return true;
}

function todayString() {
  const d = new Date();
  return `${d.getFullYear()}-${d.getMonth()}-${d.getDate()}`;
}

async function getAdWatchesToday() {
  const { value: dateVal } = await Preferences.get({ key: AD_WATCHES_DATE_KEY });
  const { value: countVal } = await Preferences.get({ key: AD_WATCHES_KEY });
  const today = todayString();
  if (dateVal !== today) return 0;
  return parseInt(countVal) || 0;
}

export async function canWatchAdForCoins() {
  const watched = await getAdWatchesToday();
  return watched < MAX_ADS_PER_DAY;
}

export async function getAdWatchesRemaining() {
  const watched = await getAdWatchesToday();
  return Math.max(0, MAX_ADS_PER_DAY - watched);
}

export async function recordAdWatch() {
  const today = todayString();
  const { value: dateVal } = await Preferences.get({ key: AD_WATCHES_DATE_KEY });
  let count = 0;
  if (dateVal === today) {
    const { value: countVal } = await Preferences.get({ key: AD_WATCHES_KEY });
    count = parseInt(countVal) || 0;
  }
  count++;
  await Preferences.set({ key: AD_WATCHES_DATE_KEY, value: today });
  await Preferences.set({ key: AD_WATCHES_KEY, value: String(count) });
  const newBalance = await addCoins(COINS_PER_AD);
  return { newBalance, adsRemaining: Math.max(0, MAX_ADS_PER_DAY - count) };
}

export { COINS_PER_AD, MAX_ADS_PER_DAY };
